export default "__VITE_ASSET__BLUR69Jf__"